module.exports = {"id":"179891","name":"Marcel Heller","rating":"74","photo":"./data/images/photos/2/179891.png","club":{"name":"FC Augsbourg","logo":"./data/images/clubs/FCAugsbourg.png"},"positions":["MG","MD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MarcelHeller0.json
// module id = 2709
// module chunks = 0